<template>
    <div class="unboxing">
        <div class="container">
            <TitleH2 title="搶先評測老實說" />
            <p class="unboxing-slogan">居家清潔免沾手，讓你清潔毫不費力！</p>
            <div class="unboxing-container row" data-aos="fade-up">
                <div class="col-6 col-m12">
                    <SwiperImg :images="unboxingImg" />
                </div>
                <div class="unboxing-content col-6 col-m12">
                    <h3 class="unboxing-content__title">超級完美管家HEPA除蟎版</h3>
                    <p>伊萊克斯秉持著讓生活更加精采精神，重新定義料理美味、衣物呵護、美好的居家生活環境，百年來堅持提供消費者高品質家電產品。伊萊克斯身為全球家電領導品牌，我們所提供的一切以消費者的最佳體驗為出發點。伊萊克斯秉持著讓生活更加精采精神，重新定義料理美味、衣物呵護、美好的居家生活環境，百年來堅持提供消費者高品質家電產品。</p>
                    <div class="unboxing-content__btn">
                        <GotoLinkBtn btnName="看專業評測去" url=" https://styleme.pixnet.net/topics" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import TitleH2 from '@/components/widget/TitleH2.vue';
import GotoLinkBtn from '@/components/widget/GoToLinkBtn.vue';
import SwiperImg from '@/components/widget/SwiperImg.vue';

const unboxingImg = ['test1.png', 'test1.png', 'test1.png', 'test1.png', 'test1.png'];



</script>
<style lang="scss" scoped>
@import '@/styles/theUnboxing';

</style>
